import { useContext } from 'react';

import { StoreContext } from '@/context/store/StoreContext';

const useStoreCtx = () => useContext(StoreContext);

export default useStoreCtx;
